import * as React from "react"

const IconHolder = (props) => (
  
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={41}
    height={40}
    fill="none"
    {...props}
  >
    <path
      fill="url(#a)"
      d="M37.45 11.934a2.681 2.681 0 0 0-1.426-2.914L21.195 1.606a2.691 2.691 0 0 0-2.39 0L3.975 9.02a2.681 2.681 0 0 0-1.424 2.914l2.076 10.38a17.49 17.49 0 0 0 6.779 10.655l.642.468c.039-.943.19-1.878.453-2.785a14.99 14.99 0 0 1-5.416-8.836L5 11.444a.175.175 0 0 1 .093-.188L19.92 3.842a.18.18 0 0 1 .157 0l14.829 7.408a.175.175 0 0 1 .092.188l-2.077 10.38a15.026 15.026 0 0 1-1.178 3.53c.661.617 1.25 1.308 1.752 2.06a17.502 17.502 0 0 0 1.875-5.1l2.08-10.374Z"
    />
    <path
      fill="url(#b)"
      d="M28.584 25.169 26.14 23.82a5.001 5.001 0 0 0 2.61-4.394v-1.978a5 5 0 0 0-10 0v1.978a5 5 0 0 0 2.609 4.394l-2.442 1.349a9.999 9.999 0 0 0-5.168 8.75v2.33A1.25 1.25 0 0 0 15 37.5h17.501a1.25 1.25 0 0 0 1.25-1.25v-2.326a10 10 0 0 0-5.167-8.754Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={2.5}
        x2={18.717}
        y1={1.326}
        y2={41.097}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.272} stopColor="#34263B" />
        <stop offset={0.658} stopColor="#13172C" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={14.273}
        x2={34.402}
        y1={14.414}
        y2={30.485}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.35} stopColor="#F7052D" />
        <stop offset={0.85} stopColor="#CA5AFA" />
      </linearGradient>
    </defs>
  </svg>
)

export default IconHolder
